import { setAlert } from '../alert';
import {
    API_GET_ROF_BURNS_BATCH_DATA,
    API_GET_ROF_BURNS_BATCH_MEDIA,
    API_GET_ROF_BURNS_ADDITIONAL_BATCH_DATA,
    API_GET_ROF_BURNS_BATCH_VOLUMES,
    API_GET_ROF_BURNS_BATCH_BULK_DENSITY,
    API_GET_ROF_BURNS_BIOCHAR_MASS,
    API_POST_ROF_BURNS_LAB_REPORT_FILE,
    API_GET_ROF_BURNS_LAB_REPORT_FILES,
    API_POST_BASE_LOG_KILN,
    API_GET_BASE_LOG_KILNS,
    API_GET_PROJECT_BATCHES,
    API_GET_DOWNLOAD_BATCH_REPORT,
    API_POST_BASE_BUCKET,
    API_GET_BASE_BUCKETS,
    API_POST_BASE_EQUIPMENT,
    API_GET_BASE_EQUIPMENT,
    API_GET_APPLICATION_TYPE,
    API_GET_ROF_USERS,
    API_GET_FARM_PROJECTS,
    API_ADD_USER_TO_PROJECT,
    API_PROJECT_INFO,
    API_BIOCHAR_LAB_SAMPLES,
    API_BIOCHAR_LAB_SAMPLES_CONTAMINANTS,
    API_IGNITION_FUEL,
    API_EQUIPMENT_TRANSPORT
} from './constants/rof-burn-constants';
import {
    GET_ROF_BURNS_BATCH_DATA_SUCCESS,
    GET_ROF_BURNS_BATCH_DATA_FAIL,
    GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_SUCCESS,
    GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_FAIL,
    GET_ROF_BURNS_BATCH_VOLUMES_SUCCESS,
    GET_ROF_BURNS_BATCH_VOLUMES_FAIL,
    GET_ROF_BURNS_BATCH_BULK_DENSITY_SUCCESS,
    GET_ROF_BURNS_BATCH_BULK_DENSITY_FAIL,
    GET_ROF_BURNS_BIOCHAR_MASS_SUCCESS,
    GET_ROF_BURNS_BIOCHAR_MASS_FAIL,
    POST_ROF_BURNS_LAB_REPORT_FILE_SUCCESS,
    POST_ROF_BURNS_LAB_REPORT_FILE_FAIL,
    GET_ROF_BURNS_LAB_REPORT_FILES_SUCCESS,
    GET_ROF_BURNS_LAB_REPORT_FILES_FAIL,
    POST_BASE_LOG_KILN_SUCCESS,
    POST_BASE_LOG_KILN_FAIL,
    GET_BASE_LOG_KILNS_SUCCESS,
    GET_BASE_LOG_KILNS_FAIL,
    GET_ROF_BURNS_BATCH_MEDIA_SUCCESS,
    GET_ROF_BURNS_BATCH_MEDIA_FAIL,
    GET_PROJECT_BATCHES_SUCCESS,
    GET_PROJECT_BATCHES_FAIL,
    GET_DOWNLOAD_BATCH_REPORT_SUCCESS,
    GET_DOWNLOAD_BATCH_REPORT_FAIL,
    POST_BASE_BUCKET_SUCCESS,
    POST_BASE_BUCKET_FAIL,
    GET_BASE_BUCKETS_SUCCESS,
    GET_BASE_BUCKETS_FAIL,
    POST_BASE_EQUIPMENT_SUCCESS,
    POST_BASE_EQUIPMENT_FAIL,
    GET_BASE_EQUIPMENT_SUCCESS,
    GET_BASE_EQUIPMENT_FAIL,
    API_GET_APPLICATION_TYPE_SUCCESS,
    API_GET_APPLICATION_TYPE_FAIL,
    GET_ROF_BURNS_USERS_SUCCESS,
    GET_ROF_BURNS_USERS_FAIL,
    GET_FARM_PROJECTS_SUCCESS,
    GET_FARM_PROJECTS_FAIL,
    ADD_USER_TO_PROJECT_SUCCESS,
    ADD_USER_TO_PROJECT_FAIL,
    GET_PROJECT_INFO_SUCCESS,
    GET_PROJECT_INFO_FAIL,
    POST_PROJECT_INFO_SUCCESS,
    POST_PROJECT_INFO_FAIL,
    GET_BIOCHAR_LAB_SAMPLES_SUCCESS,
    GET_BIOCHAR_LAB_SAMPLES_FAIL,
    POST_BIOCHAR_LAB_SAMPLES_SUCCESS,
    POST_BIOCHAR_LAB_SAMPLES_FAIL,
    GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    GET_IGNITION_FUEL_SUCCESS,
    GET_IGNITION_FUEL_FAIL,
    POST_IGNITION_FUEL_SUCCESS,
    POST_IGNITION_FUEL_FAIL,
    GET_EQUIPMENT_TRANSPORT_SUCCESS,
    GET_EQUIPMENT_TRANSPORT_FAIL,
    POST_EQUIPMENT_TRANSPORT_SUCCESS,
    POST_EQUIPMENT_TRANSPORT_FAIL
} from './types/rof-burn-types';

import api from '../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json',
    },
    // withCredentials: true,
};

const configFiles = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};

const configBlob = {
    method: "GET",
    headers: {
        'Content-Type': 'application/json',
    },
    // withCredentials: true,
    responseType: 'blob',
};

// New GET Actions
export const getRofBurnsBatchData = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_BURNS_BATCH_DATA + `/${project}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_BATCH_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_BATCH_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRofBurnsBatchMedia = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_BURNS_BATCH_MEDIA + `/${project}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_BATCH_MEDIA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_BATCH_MEDIA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRofBurnsAdditionalBatchData = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_BURNS_ADDITIONAL_BATCH_DATA + `/${project}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRofBurnsBatchVolumes = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_BURNS_BATCH_VOLUMES + `/${project}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_BATCH_VOLUMES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_BATCH_VOLUMES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRofBurnsBatchBulkDensity = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_BURNS_BATCH_BULK_DENSITY + `/${project}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_BATCH_BULK_DENSITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_BATCH_BULK_DENSITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRofBurnsBiocharMass = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_BURNS_BIOCHAR_MASS + `/${project}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_BIOCHAR_MASS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_BIOCHAR_MASS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const rofLabReportFileUpload =
    (data, project) => async dispatch => {
        try {
            const response = await api().post(
                process.env.REACT_APP_API_URL +
                API_POST_ROF_BURNS_LAB_REPORT_FILE +
                `/${project}`,
                data,
                configFiles
            );
            dispatch({
                type: POST_ROF_BURNS_LAB_REPORT_FILE_SUCCESS,
                // payload: data,
            });
            dispatch(setAlert(response.data.detail, 'success'));
        } catch (err) {
            dispatch(setAlert(err.response.detail, 'error'));
            dispatch({
                type: POST_ROF_BURNS_LAB_REPORT_FILE_FAIL,
                payload: err.response.data.detail,
            });
        }
    };

export const rofLabReportFiles =
    (projectId) => async dispatch => {
        try {
            const { data } = await api().get(
                process.env.REACT_APP_API_URL +
                API_GET_ROF_BURNS_LAB_REPORT_FILES +
                `/${projectId}`,
                config
            );
            dispatch({
                type: GET_ROF_BURNS_LAB_REPORT_FILES_SUCCESS,
                payload: data,
            });
            dispatch(setAlert(data.detail, 'success'));
        } catch (err) {
            dispatch(setAlert(err.response.detail, 'error'));
            dispatch({
                type: GET_ROF_BURNS_LAB_REPORT_FILES_FAIL,
                payload: err.response.data.detail,
            });
        }
    };


export const postLogKiln = (formData, project) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_BASE_LOG_KILN + `/${project}`,
            formData,
            config
        );
        dispatch({
            type: POST_BASE_LOG_KILN_SUCCESS
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_BASE_LOG_KILN_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const getLogKilns = (project, kilnType) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BASE_LOG_KILNS + `/${project}/${kilnType}`,
            config
        );
        dispatch({
            type: GET_BASE_LOG_KILNS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BASE_LOG_KILNS_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const postBucket = (data, project) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_POST_BASE_BUCKET + `/${project}`,
            data,
            config
        );
        dispatch({
            type: POST_BASE_BUCKET_SUCCESS
        });
        dispatch(setAlert(response.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_BASE_BUCKET_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const getBuckets = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BASE_BUCKETS + `/${project}`,
            config
        );
        dispatch({
            type: GET_BASE_BUCKETS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BASE_BUCKETS_FAIL,
            payload: err.response.data.detail,
        });
    }
};


// Resolves true on success so the form only clears once the equipment is saved.
export const postEquipment = (data, project) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_POST_BASE_EQUIPMENT + `/${project}`,
            data,
            configFiles
        );
        dispatch({
            type: POST_BASE_EQUIPMENT_SUCCESS
        });
        dispatch(setAlert(response.data.detail, 'success'));
        return true;
    } catch (err) {
        dispatch(setAlert(err.response?.data?.detail || 'Unable to create Equipment', 'error'));
        dispatch({
            type: POST_BASE_EQUIPMENT_FAIL,
            payload: err.response?.data?.detail,
        });
        return false;
    }
};


export const getEquipment = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BASE_EQUIPMENT + `/${project}`,
            config
        );
        dispatch({
            type: GET_BASE_EQUIPMENT_SUCCESS,
            payload: data,
        });
    } catch (err) {
        dispatch(setAlert(err.response?.data?.detail || 'Unable to fetch equipment', 'error'));
        dispatch({
            type: GET_BASE_EQUIPMENT_FAIL,
            payload: err.response?.data?.detail,
        });
    }
};


export const getProjectBatches = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_PROJECT_BATCHES + `/${project}`,
            config
        );
        dispatch({
            type: GET_PROJECT_BATCHES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_PROJECT_BATCHES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const downloadBatchReport = (projectId, batchId) => async dispatch => {
    try {
        const response = await api().get(
            process.env.REACT_APP_API_URL + API_GET_DOWNLOAD_BATCH_REPORT + `/${projectId}/${batchId}`,
            configBlob
        );
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'batch_volumes.pdf'); // Set the file name
        document.body.appendChild(link);
        link.click();
        dispatch({
            type: GET_DOWNLOAD_BATCH_REPORT_SUCCESS,
        });
        dispatch(setAlert('Batch report successfully downloaded', 'success'));
    } catch (err) {
        dispatch(setAlert('Batch report failed to download', 'error'));
        dispatch({
            type: GET_DOWNLOAD_BATCH_REPORT_FAIL,
            payload: 'Batch report failed to download',
        });
    }
};

export const getApplicationType = (projectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_APPLICATION_TYPE + `/${projectId}`,
            config
        );
        dispatch({
            type: API_GET_APPLICATION_TYPE_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_GET_APPLICATION_TYPE_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const getRofUsers = (farmId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_ROF_USERS + `/${farmId}`,
            config
        );
        dispatch({
            type: GET_ROF_BURNS_USERS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_ROF_BURNS_USERS_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const getFarmProjects = (farmId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FARM_PROJECTS + `/${farmId}`,
            config
        );
        dispatch({
            type: GET_FARM_PROJECTS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FARM_PROJECTS_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const addUserToProject = (projectId, userId) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_ADD_USER_TO_PROJECT + `/${projectId}/${userId}`,
            {},
            config
        );
        dispatch({
            type: ADD_USER_TO_PROJECT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: ADD_USER_TO_PROJECT_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const getProjectInfo = (projectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_PROJECT_INFO + `/${projectId}`,
            config
        );
        dispatch({
            type: GET_PROJECT_INFO_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_PROJECT_INFO_FAIL,
            payload: err.response.data.detail,
        });
    }
}
export const postProjectInfo = (data, projectId) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_PROJECT_INFO + `/${projectId}`,
            data,
            config
        );
        dispatch({
            type: POST_PROJECT_INFO_SUCCESS,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_PROJECT_INFO_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const getBiocharLabSamples = (projectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_BIOCHAR_LAB_SAMPLES + `/${projectId}`,
            config
        );
        dispatch({
            type: GET_BIOCHAR_LAB_SAMPLES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BIOCHAR_LAB_SAMPLES_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const postBiocharLabSamples = (data, projectId) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_BIOCHAR_LAB_SAMPLES + `/${projectId}`,
            data,
            configFiles
        );
        dispatch({
            type: POST_BIOCHAR_LAB_SAMPLES_SUCCESS,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_BIOCHAR_LAB_SAMPLES_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const getIgnitionFuel = (projectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_IGNITION_FUEL + `/${projectId}`,
            config
        );
        dispatch({
            type: GET_IGNITION_FUEL_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_IGNITION_FUEL_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const postIgnitionFuel = (data, projectId) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_IGNITION_FUEL + `/${projectId}`,
            data,
            configFiles
        );
        dispatch({
            type: POST_IGNITION_FUEL_SUCCESS,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_IGNITION_FUEL_FAIL,
            payload: err.response.data.detail,
        });
    }
}


export const getBiocharLabSamplesContaminants = (projectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_BIOCHAR_LAB_SAMPLES_CONTAMINANTS + `/${projectId}`,
            config
        );
        dispatch({
            type: GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const postBiocharLabSamplesContaminants = (projectId, rows) => async dispatch => {
    try {
        // Sent as data[<index>][<field>] so each row's lab report file travels with it
        const formData = new FormData();
        rows.forEach((row, index) => {
            Object.entries(row).forEach(([key, value]) => {
                if (value !== null && value !== undefined)
                    formData.append(`data[${index}][${key}]`, value);
            });
        });

        const response = await api().post(
            process.env.REACT_APP_API_URL + API_BIOCHAR_LAB_SAMPLES_CONTAMINANTS + `/${projectId}`,
            formData,
            configFiles
        );
        dispatch({
            type: POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
            payload: err.response.data.detail,
        });
    }
}


export const getEquipmentTransport = (projectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_EQUIPMENT_TRANSPORT + `/${projectId}`,
            config
        );
        dispatch({
            type: GET_EQUIPMENT_TRANSPORT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_EQUIPMENT_TRANSPORT_FAIL,
            payload: err.response.data.detail,
        });
    }
}


export const postEquipmentTransport = (data, projectId) => async dispatch => {
    try {
        const response = await api().post(
            process.env.REACT_APP_API_URL + API_EQUIPMENT_TRANSPORT + `/${projectId}`,
            data,
            configFiles
        );
        dispatch({
            type: POST_EQUIPMENT_TRANSPORT_SUCCESS,
        });
        dispatch(setAlert(response.data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_EQUIPMENT_TRANSPORT_FAIL,
            payload: err.response.data.detail,
        });
    }
}
